import {HttpException} from "./http.exception.js";

/**
 * 503 Service Unavailable Exception
 */
export class ServiceUnavailableException extends HttpException {
    constructor(message: string = "Service Unavailable", errorBody?: unknown, cause?: Error) {
        super(503, message, errorBody, cause);
    }
}
